module.exports = __webpack_public_path__ + "img/slider_one.c06465cf.png";